import { c as _c } from "react/compiler-runtime";
import type { ButtonProps } from '@/app/components/button';
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { type ContentProps, type HeaderWithContentProps } from '@/app/components/headers/base';
import { TitleH2 } from '@/app/components/headers/header-level-2/title-h2';
import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const ContentStyled = cnva('', {
  variants: {
    theme: {
      light: 'where-a:link-light',
      dark: 'where-a:link-dark'
    },
    layout: {
      'one-column': '',
      'two-column': '',
      center: 'text-center',
      none: ''
    }
  },
  defaultVariants: {
    theme: 'light',
    layout: 'two-column'
  }
});
export const HeaderLevel2 = t0 => {
  const $ = _c(36);
  const {
    lead,
    title,
    content1,
    content2,
    buttons: t1,
    theme: t2,
    layout: t3,
    leadClassName,
    contentClassName,
    content2ClassName,
    tracking
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const buttons = t4;
  const theme = t2 === undefined ? "light" : t2;
  const layout = t3 === undefined ? "two-column" : t3;
  let t5;
  if ($[2] !== contentClassName || $[3] !== layout || $[4] !== theme) {
    t5 = ContentStyled({
      theme,
      layout,
      className: contentClassName
    });
    $[2] = contentClassName;
    $[3] = layout;
    $[4] = theme;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const contentStyled = t5;
  let t6;
  if ($[6] !== layout || $[7] !== tracking) {
    t6 = buttons_0 => <>{buttons_0?.length > 0 && <ButtonGroup className={cn({
        "justify-center": layout === "center"
      })} {...createDataAttributes({
        test: "heading-buttons"
      })}>{buttons_0.map((button, index) => <Button key={index} {...button} {...createDataAttributes({
          test: `button-${index}`
        })} {...createDataGA({
          ...tracking,
          click: true,
          url: button.href,
          text: button.children
        })} />)}</ButtonGroup>}</>;
    $[6] = layout;
    $[7] = tracking;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const renderButtons = t6;
  let t7;
  if ($[9] !== contentStyled || $[10] !== renderButtons) {
    t7 = t8 => {
      const {
        content,
        buttons: buttons_1
      } = t8;
      return <>{!!content && <div className={contentStyled} {...createDataAttributes({
          test: "heading-content"
        })} dangerouslySetInnerHTML={{
          __html: content as string
        }} />}{!!buttons_1 && renderButtons(buttons_1)}</>;
    };
    $[9] = contentStyled;
    $[10] = renderButtons;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const renderContent = t7;
  let t8;
  if ($[12] !== content2ClassName) {
    t8 = cn("flex-1 space-y-4", content2ClassName);
    $[12] = content2ClassName;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "content-left"
    });
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== lead || $[16] !== leadClassName) {
    t10 = !!lead && <h3 className={cn("font-noto-bold text-red-500", leadClassName)} {...createDataAttributes({
      test: "heading-lead"
    })}>{lead}</h3>;
    $[15] = lead;
    $[16] = leadClassName;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== buttons || $[19] !== renderButtons || $[20] !== title) {
    t11 = !!title && (buttons?.length > 0 ? <div className="flex justify-between"><TitleH2 title={title} />{renderButtons(buttons)}</div> : <TitleH2 title={title} />);
    $[18] = buttons;
    $[19] = renderButtons;
    $[20] = title;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== content2 || $[23] !== renderContent) {
    t12 = !!content2 && <>{typeof content2.content === "string" ? renderContent(content2) : content2.content}</>;
    $[22] = content2;
    $[23] = renderContent;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t8) {
    t13 = <div className={t8} {...t9}>{t10}{t11}{t12}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== content1 || $[31] !== renderContent) {
    t14 = !!content1 && (typeof content1.content === "string" ? <div className="flex-1 space-y-6" {...createDataAttributes({
      test: "content-right"
    })}>{renderContent(content1)}</div> : content1.content);
    $[30] = content1;
    $[31] = renderContent;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};